module.exports = __webpack_public_path__ + "img/avatar1.5561affc.png";